import * as React from "react";

import { useTheme } from "@mui/material";

import { UserAgreementLinks } from "./UserAgreementLinks";

import { useDynamicThemeAwareVariables } from "@/common/hooks/useDynamicThemeAwareVariables";
import { Trans } from "@/common/hooks/useTranslate";
import { FormTypography, FormTypographyProps } from "@/forms-design-system/FormTypography";

export const FormUserAgreement: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const theme = useTheme();

  const { vibe } = useDynamicThemeAwareVariables(({ mode }) => ({
    vibe: (mode === "light" ? "moderate" : "supershy") as FormTypographyProps["vibe"],
  }));

  return (
    <FormTypography variant="caption" vibe={vibe}>
      <Trans
        space="donationForm"
        i18nKey="userAgreement.fullText"
        components={UserAgreementLinks({ linkColor: theme.palette.forms.text.brand })}
      />
    </FormTypography>
  );
};
